import { ProfileCard, ShelfCard, ShelfHistorySection } from '@/components/account';
import { AdminSection } from '@/components/admin/AdminSection';
import { ErrorState } from '@/components/common/ErrorState';
import { LoadingSpinner } from '@/components/common/LoadingSpinner';
import { Layout } from '@/components/Layout';
import { useShelf } from '@/hooks/useShelf';

export function AccountPage() {
  const { entries, history, isLoading, error, refetch } = useShelf();

  return (
    <Layout>
      <div className="max-w-2xl mx-auto px-4 py-8">
        <ProfileCard />

        <AdminSection />

        <div className="flex items-baseline justify-between mb-4">
          <h2 className="text-xl font-bold text-black">My Shelf</h2>
          {!isLoading && !error && entries.length > 0 && (
            <span
              className="text-sm text-black/40 font-bold"
              data-testid="shelf-count"
            >
              {entries.length} {entries.length === 1 ? 'coffee' : 'coffees'}
            </span>
          )}
        </div>

        {isLoading && (
          <LoadingSpinner label="Loading shelf" testId="shelf-loading" />
        )}

        {!isLoading && error && (
          <ErrorState
            message="Failed to load your shelf. Please try again."
            onPrimaryAction={() => void refetch()}
            testId="shelf-error"
          />
        )}

        {!isLoading && !error && entries.length === 0 && (
          <div
            className="flex flex-col items-center justify-center py-12 gap-2"
            data-testid="shelf-empty"
          >
            <p className="text-gray-500 text-center">Your shelf is empty</p>
            <p className="text-gray-400 text-sm text-center">
              Browse coffees and add them to your shelf for easy access.
            </p>
          </div>
        )}

        {!isLoading && !error && entries.length > 0 && (
          <div
            className="flex flex-col gap-3"
            data-testid="shelf-list"
          >
            {entries.map((entry) => (
              <ShelfCard
                key={entry.coffee.id}
                coffee={entry.coffee}
                addedAt={entry.addedAt}
                refetch={refetch}
              />
            ))}
          </div>
        )}

        {!isLoading && !error && history.length > 0 && (
          <ShelfHistorySection history={history} refetch={refetch} />
        )}
      </div>
    </Layout>
  );
}
